import { Auth as Oauth } from "@pacificoseguros/tools";
import { ENV } from "../../constants/env";

class Auth {
    static init = () => {
        Oauth.initialize({
            appId: ENV.ID_TOKEN,
            url: ENV.URL_TOKEN,
            storage: sessionStorage,
        });
    };
}

export default Auth;
